import React from 'react'
import { MotifButton } from '@ey-xd/motif-react'

import styles from './index.module.scss'

export const Error: React.FC = () => {
  return (
    <div className={styles.container}>
      <p className="motif-h1">Something went wrong.</p>
      <a href="/" className="motif-text-link" title="retry">
        <MotifButton variant="primary">Login</MotifButton>
      </a>
    </div>
  )
}